import React from 'react';
import { Controller } from 'react-hook-form';
import _get from 'lodash/get';
import Select from '../baseui/input/select';

interface ISelectInput {
	name: any;
	control: any;
	defaultValue: any;
	onChangeCallback?: any;
}

const SelectInput: React.FC<ISelectInput> = (props) => {
	const { name, control, defaultValue, onChangeCallback } = props;

	return (
		<Controller
			control={control}
			name={name}
			render={({ field: { onChange, value } }) => {
				return (
					<Select
						{...props}
						value={value}
						onChange={onChange}
						onChangeCallback={onChangeCallback}
						labelKey='label'
						valueKey='id'
					/>
				);
			}}
			defaultValue={defaultValue && _get(defaultValue, ['field', ...defaultValue.path])}
		/>
	);
};

export default SelectInput;
